{
  "nav": {
    "home": "Inicio",
    "services": "Servicios",
    "philosophy": "Filosofía",
    "about": "Sobre Mí",
    "contact": "Contacto"
  },
  "seo": {
    "home": {
      "title": "Gerardo Martínez Junco | Dark Lynx Protocol",
      "desc": "Sitio oficial de Gerardo Martínez Junco, programador en Querétaro y fundador de Dark Lynx Protocol. Páginas web baratas para negocios que necesitan sitios rápidos, SEO técnico y sistemas a medida."
    },
    "services": {
      "title": "Programador en Querétaro y páginas web baratas | Dark Lynx Protocol",
      "desc": "Programador web en Querétaro para pequeños negocios: páginas web baratas, landing pages con identidad, sistemas a medida, rescate SEO, velocidad e integraciones seguras."
    },
    "philosophy": {
      "desc": "Así trabajamos en Dark Lynx Protocol: comunicación directa, velocidad real, código mantenible, SEO técnico y soluciones web pensadas para crecer sin depender de parches.",
      "title": "Desarrollo web claro, rápido y sin deuda técnica | Dark Lynx Protocol"
    },
    "about": {
      "desc": "Conoce a Gerardo Martínez Junco, programador en Querétaro y fundador de Dark Lynx Protocol: desarrollador web fullstack con más de 10 años de experiencia en sitios rápidos, sistemas a medida y plataformas para negocio.",
      "title": "Gerardo Martínez Junco, programador en Querétaro | Dark Lynx Protocol"
    },
    "contact": {
      "title": "Cotiza tu sitio web o sistema a medida | Dark Lynx Protocol",
      "desc": "Cuéntanos tu proyecto web. Te respondemos en menos de 24 horas para revisar tu sitio, sistema, tienda en línea, integración o mejora de SEO técnico."
    },
    "journal": {
      "title": "Bitácora técnica | Dark Lynx Protocol",
      "desc": "Bitácora privada de desarrollo, herramientas y aprendizajes de Dark Lynx Protocol."
    },
    "landingPages": {
      "title": "Páginas web baratas para pequeños negocios | Dark Lynx Protocol",
      "description": "Páginas web baratas, rápidas y preparadas para SEO base. Landing pages pensadas para negocios que necesitan verse profesionales y convertir visitas en contactos."
    }
  },
  "cta": {
    "startProtocol": "INICIAR_PROTOCOLO",
    "tellMeProject": "Quiero una idea para mi negocio",
    "viewPhilosophy": "Conoce cómo trabajamos",
    "viewAllServices": "Ver servicios",
    "sendData": "TRANSMITIR_DATOS",
    "sending": "TRANSMITIENDO...",
    "viewLandingPages": "Ver landing pages",
    "requestQuote": "Solicitar cotización",
    "talkBusiness": "Quiero una idea para mi negocio"
  },
  "footer": {
    "brand": "DARK LYNX PROTOCOL",
    "status": "[SYSTEM_STABLE]"
  },
  "home": {
    "hero": {
      "badge": "ESTUDIO_WEB_BOUTIQUE",
      "title": "Tu negocio merece verse como una <span class=\"text-accent text-glow\">marca</span>.",
      "description": "Dark Lynx Protocol es un estudio de un programador en Querétaro que crea páginas web baratas, rápidas, con identidad visual, SEO base y contacto directo para negocios que quieren dejar de verse improvisados en internet.",
      "ctaPrimary": "Quiero una idea para mi negocio",
      "ctaSecondary": "Ver servicios"
    },
    "problem": {
      "overline": "EL PROBLEMA",
      "title": "Por qué tu página actual no te está dando ventas",
      "description": "Comprar plantillas genéricas o contratar agencias que pegan miles de líneas de código copiado suele terminar igual: un sitio lento, caro de mantener, y que nadie, ni tú ni tu proveedor, puede explicar cómo funciona de verdad.",
      "alert": "[SÍNTOMA_DE_ALERTA]",
      "alertList": [
        "Tu página tarda más de 3 segundos en abrir, y casi la mitad de la gente se va antes de verla.",
        "El código está tan enredado que cualquier cambio pequeño cuesta una fortuna o rompe otra cosa.",
        "Dependes de plugins externos que se desactualizan, fallan o te cobran mes a mes.",
        "El presupuesto se va en parches sin que el problema de fondo se resuelva nunca."
      ],
      "protocol": "[EL_PROTOCOLO]",
      "protocolList": [
        "Tu página carga en menos de un segundo y se ve completa de la primera vez, sin brincos ni esperas.",
        "Un código limpio y ordenado que cualquier programador puede leer y modificar sin miedo a romper algo.",
        "Pocas dependencias externas. Si algo falla, no dependes de que un proveedor externo lo arregle.",
        "Te entregamos un sitio que puedes extender y mantener tú mismo, con documentación clara."
      ]
    },
    "services": {
      "overline": "RUTAS COMERCIALES",
      "title": "Elige por dónde quieres empezar",
      "description": "No todos los negocios necesitan lo mismo. Como programador web en Querétaro, te ayudo a elegir una ruta clara según tu momento: presencia profesional, sistema a medida o rescate de una página que ya existe.",
      "list": [
        {
          "icon": "Layout",
          "title": "Páginas web baratas con identidad",
          "description": "Para negocios que necesitan una página web barata, verse profesionales, explicar su oferta y recibir mensajes sin armar una plataforma gigante.",
          "href": "/servicios/landing-pages",
          "cta": "Ver landing pages"
        },
        {
          "icon": "Layers",
          "title": "Sistemas para operar mejor",
          "description": "Para procesos que ya te comen tiempo: reservas, catálogos, formularios, paneles internos, automatizaciones e integraciones.",
          "href": "/servicios",
          "cta": "Ver servicios"
        },
        {
          "icon": "Search",
          "title": "Rescate SEO y velocidad",
          "description": "Para sitios existentes que cargan lento, no aparecen en Google o se sienten parchados. Revisamos, limpiamos y mejoramos lo que sí vale la pena conservar.",
          "href": "/servicios",
          "cta": "Revisar opciones"
        }
      ]
    },
    "commercialPaths": [
      {
        "title": "Presencia profesional",
        "description": "Una página web barata, rápida y clara, lista para que tus clientes te contacten.",
        "link": "/servicios/landing-pages"
      },
      {
        "title": "Sistemas para negocio",
        "description": "Herramientas internas, paneles y automatizaciones que reducen trabajo manual.",
        "link": "/servicios"
      },
      {
        "title": "Rescate SEO",
        "description": "Mejoras técnicas para páginas lentas, desordenadas o invisibles en Google.",
        "link": "/servicios"
      }
    ]
  },
  "services": {
    "hero": {
      "overline": "SERVICIOS",
      "title": "Páginas web baratas sin paquetes inflados",
      "description": "Cada servicio parte de un problema concreto: trabajar con un programador en Querétaro para tener una página web barata y profesional, vender mejor, ordenar procesos o rescatar una página que ya no funciona como debería."
    },
    "modules": [
      {
        "icon": "Layout",
        "title": "Páginas web baratas con identidad",
        "description": "Una página web barata enfocada en explicar tu oferta, transmitir confianza y llevar al visitante al contacto. Ideal para negocios locales, servicios profesionales y campañas específicas.",
        "tags": [
          "Identidad visual",
          "SEO base",
          "Contacto directo",
          "Mobile first"
        ],
        "href": "/servicios/landing-pages",
        "cta": "Ver detalle"
      },
      {
        "icon": "Layers",
        "title": "Sistemas y plataformas a medida",
        "description": "Reservas, catálogos, paneles administrativos, formularios avanzados e integraciones cuando tu negocio necesita algo más que una página informativa.",
        "tags": [
          "Panel admin",
          "Base de datos",
          "Automatizaciones",
          "Integraciones"
        ],
        "href": "/contacto",
        "cta": "Platicar mi caso"
      },
      {
        "icon": "Search",
        "title": "SEO técnico y velocidad",
        "description": "Revisamos rendimiento, estructura, metadatos, indexación y contenido para que tu sitio cargue mejor y Google entienda lo que ofreces.",
        "tags": [
          "Core Web Vitals",
          "Metadatos",
          "Indexación",
          "Diagnóstico"
        ],
        "href": "/contacto",
        "cta": "Pedir revisión"
      },
      {
        "icon": "Shield",
        "title": "Cobros e integraciones seguras",
        "description": "Conectamos formularios, pagos, APIs, CRM o herramientas que ya usas, cuidando seguridad, mantenimiento y claridad técnica desde el inicio.",
        "tags": [
          "Pagos",
          "APIs",
          "Formularios",
          "Seguridad"
        ],
        "href": "/contacto",
        "cta": "Cotizar integración"
      }
    ],
    "tech": {
      "overline": "HERRAMIENTAS",
      "title": "Las herramientas correctas para cada proyecto",
      "description": "Elegimos la tecnología según lo que tu negocio necesita, no al revés. Buscamos siempre que tu sitio sea rápido, fácil de mantener, preparado para SEO técnico y que no te ate a un solo proveedor."
    },
    "cta": {
      "title": "¿Listo para dejar de pelearte con tu página?",
      "description": "Agenda una llamada sin compromiso. Revisamos tu situación actual, te decimos qué tiene sentido, y te damos un presupuesto claro antes de que decidas algo."
    }
  },
  "philosophy": {
    "hero": {
      "overline": "CÓMO TRABAJAMOS",
      "title": "Cómo pensamos cada proyecto",
      "description": "Cuatro ideas simples que guían todo lo que hacemos. Si las lees y sientes que no encajan con lo que necesitas, probablemente no somos el estudio correcto para ti. Y está bien decirlo."
    },
    "principles": [
      {
        "number": "01",
        "title": "Hablamos claro, sin rodeos",
        "description": "Te decimos las cosas como son. Si tu idea funciona, te decimos por qué. Si tiene un riesgo, también. Y si una solución simple resuelve tu problema, no te vamos a vender algo más caro solo por cobrar más.",
        "span": "col-span-3"
      },
      {
        "number": "02",
        "title": "La velocidad importa, y mucho",
        "description": "Una página rápida no es vanidad: es más ventas, más gente que llega al final, y mejor posición en Google. Cuidamos cada detalle técnico para que tu sitio se abra bien en cualquier celular y conexión.",
        "span": "col-span-3"
      },
      {
        "number": "03",
        "title": "Un código que se puede tocar sin miedo",
        "description": "Escribimos todo de forma ordenada y documentada. Si dentro de un año otro programador, o tú mismo, necesita cambiar algo, va a saber exactamente dónde tocar y qué pasa cuando lo hace.",
        "span": "col-span-4"
      },
      {
        "number": "04",
        "title": "Recomendamos lo que tú necesitas, no lo que nos deja más ganancia",
        "description": "Si lo que te sirve se resuelve con una página sencilla, no te vamos a empujar una plataforma cara. Tu negocio funcionando bien es más importante que un proyecto grande.",
        "span": "col-span-2"
      }
    ],
    "comparison": {
      "overline": "LA DIFERENCIA",
      "headerTitle": "Cómo trabajamos, comparado con una agencia tradicional",
      "description": "No es que las agencias sean malas. Es que cada modelo sirve para cosas distintas. Esta es la diferencia práctica entre trabajar con un estudio pequeño y con una agencia grande.",
      "traditional": {
        "title": "Agencia tradicional grande",
        "items": [
          "Decenas de personas tocando tu proyecto, con varios intermediarios entre tú y quien escribe el código.",
          "Plantillas genéricas adaptadas a fuerza, con clases y estilos duplicados por todos lados.",
          "Decenas de herramientas externas instaladas 'por si acaso', que vuelven tu página lenta y cara.",
          "Tiempos largos de entrega, con capas de aprobaciones internas que retrasan cada cambio.",
          "Cualquier ajuste pequeño se cotiza aparte y pasa por un proceso lento para resolverse."
        ]
      },
      "boutique": {
        "title": "Estudio boutique (Dark Lynx)",
        "items": [
          "Hablas directo con la persona que está escribiendo tu código. Sin intermediarios.",
          "Construimos desde cero, pensado para tu negocio, sin adaptaciones forzadas.",
          "Solo instalamos lo que de verdad se va a usar. Tu página queda limpia y rápida.",
          "Entregas por hitos cortos, con fechas claras y comunicación directa.",
          "Te dejamos todo documentado y ordenado para que puedas hacer cambios tú mismo."
        ]
      }
    },
    "quote": {
      "text": "Nos gusta más quitarle cosas a un proyecto que agregarle. Cada línea de código que sobra es una línea que puede fallar, costar más, o estorbar el día que alguien necesite entender cómo funciona.",
      "author": "DARK LYNX PROTOCOL"
    }
  },
  "about": {
    "profile": {
      "role": "Programador en Querétaro, desarrollador web fullstack y socio técnico",
      "bio": "Llevo más de 10 años construyendo páginas web, plataformas y sistemas para empresas y negocios. Soy programador en Querétaro y trabajo con foco en sitios rápidos, SEO técnico, código mantenible, integraciones seguras y soluciones que puedas seguir usando sin depender de parches eternos. Si tu negocio necesita una presencia en internet que funcione de verdad, no solo que se vea bonita, me escribes y platicamos.",
      "secretButton": "Diario Secreto Dev"
    },
    "trajectory": {
      "overline": "TRAYECTORIA",
      "title": "Historial de proyectos y experiencia",
      "description": "Una línea de tiempo con los proyectos y empresas que me han formado como profesional. Lo que aprendí en cada lugar es parte de lo que tu negocio se lleva al trabajar conmigo.",
      "timeline": [
        {
          "year": "2026 - Presente",
          "title": "Fundador del estudio",
          "company": "Dark Lynx Protocol",
          "description": "Lidero un estudio pequeño enfocado en construir sitios y plataformas sin atajos técnicos. Cada proyecto se entrega rápido, se mantiene fácil, y deja al cliente con el control de lo que pagó."
        },
        {
          "year": "2026 - Actualidad",
          "title": "Desarrollador de software",
          "company": "Ria Money Transfer",
          "description": "Trabajo en plataformas de transferencias de dinero para una de las empresas más grandes del mundo. Ahí aprendí lo que significa manejar millones de operaciones sin que se caiga el sistema, y lo traigo a tus proyectos."
        },
        {
          "year": "2020 - 2025",
          "title": "Desarrollador senior",
          "company": "MTech-Systems",
          "description": "Lideré el desarrollo de sistemas regulatorios para el sector agrícola en Brasil, y formé a otros desarrolladores. Ahí confirmé que el código limpio y la mentoría honesta son la base de los proyectos que duran."
        },
        {
          "year": "2015 - 2020",
          "title": "Desarrollador freelance",
          "company": "Proyectos propios",
          "description": "Diseñé y lancé varias tiendas en línea con cobros seguros y catálogos dinámicos. Ahí aprendí a hablar con clientes que no son técnicos y a entregar resultados sin perder la cabeza."
        },
        {
          "year": "2018",
          "title": "Desarrollador web",
          "company": "Probusiness",
          "description": "Mi primer trabajo formal en la industria: diseñar y mantener portales de productos. Ahí aprendí a hacer mucho con poco, y a valorar cada minuto del proyecto."
        }
      ]
    },
    "status": {
      "stable": "ACTIVE",
      "accepting": "TRUE",
      "integrity": "100% SECURE",
      "focusTitle": "EN ESTE MOMENTO:",
      "focus": [
        "Construyendo plataformas que aguantan el crecimiento de empresas medianas, desde Querétaro.",
        "Diseñando interfaces rápidas y claras que funcionan perfecto en celular, donde está la mayoría de tus clientes.",
        "Conectando páginas con sistemas de cobro, bases de datos, y las herramientas que tu negocio ya usa.",
        "Ayudando a negocios que ya tienen una página pero está lenta, falla, o simplemente no aparece en Google."
      ],
      "connectTitle": ">_ INICIAR_CONEXION",
      "linkDesc": "Escríbeme por:",
      "journal": "Diario Técnico"
    }
  },
  "contact": {
    "hero": {
      "overline": "CONEXIÓN",
      "title": "Cuéntanos de tu proyecto",
      "description": "Mándanos un mensaje con la idea general de lo que necesitas. Te respondemos en menos de 24 horas para agendar una llamada sin compromiso y revisar juntos qué tiene sentido."
    },
    "form": {
      "name": "ID_USUARIO (Nombre)",
      "email": "CORREO_ENCRIPTADO (Email)",
      "subject": "CÓDIGO_ASUNTO",
      "message": "PAYLOAD (Mensaje)",
      "directLineBefore": "o si lo prefieres contáctame directo a",
      "directLineAfter": "— respondemos en menos de 24 horas",
      "success": "PROTOCOLO COMPLETADO. Mensaje transmitido con éxito.",
      "error": "ERROR_DE_TRANSMISIÓN. Intenta nuevamente."
    }
  },
  "journal": {
    "title": "Bitácora de desarrollo",
    "subtitle": "Apuntes sobre proyectos, herramientas y cosas que voy aprendiendo en el camino",
    "badge": "ACCESO_CONCEDIDO",
    "emptyState": "No se encontraron entradas en el archivo.",
    "loadMore": "Cargar más",
    "endOfFeed": "Fin de la bitácora",
    "loadError": "Error al cargar más entradas",
    "retry": "Reintentar"
  },
  "landingPages": {
    "hero": {
      "overline": "LANDING PAGES",
      "title": "Páginas web baratas para pequeños negocios",
      "description": "Una página web barata, enfocada, rápida y clara para que tu negocio se vea profesional, explique qué ofrece y convierta visitas en mensajes reales."
    },
    "included": {
      "overline": "QUÉ INCLUYE",
      "title": "Lo esencial para verte profesional desde el primer clic",
      "items": [
        {
          "icon": "Palette",
          "title": "Identidad visual aplicada",
          "description": "Colores, jerarquía, secciones y estilo visual alineados a tu marca, no una plantilla genérica."
        },
        {
          "icon": "Smartphone",
          "title": "Diseño mobile first",
          "description": "La página se piensa primero para celular, porque ahí llega la mayoría de tus clientes."
        },
        {
          "icon": "Search",
          "title": "SEO base",
          "description": "Título, descripción, estructura semántica, Open Graph, canonical y contenido claro para búsquedas locales."
        },
        {
          "icon": "MessageCircle",
          "title": "Contacto directo",
          "description": "CTA visible hacia formulario, WhatsApp o el canal que tenga más sentido para tu negocio."
        }
      ]
    },
    "packages": {
      "overline": "PAQUETES",
      "title": "Tres niveles según tu momento",
      "items": [
        {
          "name": "Presencia",
          "price": "Desde una página web barata y enfocada",
          "description": "Para validar una oferta, lanzar tu presencia profesional o reemplazar una página improvisada sin inflar el presupuesto.",
          "features": [
            "Hero claro",
            "Secciones base",
            "SEO inicial",
            "Formulario o CTA directo"
          ]
        },
        {
          "name": "Conversión",
          "price": "Landing completa para vender",
          "description": "Para campañas, servicios con explicación más larga o negocios que necesitan más confianza antes del contacto.",
          "features": [
            "Copy comercial",
            "Bloques de prueba social",
            "FAQ",
            "Optimización de CTA"
          ]
        },
        {
          "name": "Protocolo",
          "price": "Landing + sistema ligero",
          "description": "Para cuando la landing necesita conectarse con formularios avanzados, automatizaciones o datos.",
          "features": [
            "Integraciones",
            "Eventos de conversión",
            "Automatización inicial",
            "Documentación técnica"
          ]
        }
      ]
    },
    "process": {
      "overline": "PROCESO",
      "title": "Cómo trabajamos sin hacerlo pesado",
      "steps": [
        {
          "number": "01",
          "title": "Entendemos tu oferta",
          "description": "Aterrizamos qué vendes, a quién le hablas y qué acción debe tomar el visitante."
        },
        {
          "number": "02",
          "title": "Diseñamos la ruta",
          "description": "Definimos secciones, mensajes, CTAs y estructura visual antes de escribir código."
        },
        {
          "number": "03",
          "title": "Construimos y afinamos",
          "description": "Creamos la landing, revisamos mobile, velocidad, SEO base y detalles de conversión."
        },
        {
          "number": "04",
          "title": "Entregamos con control",
          "description": "Te dejamos la página lista, clara y documentada para que no dependas de parches raros."
        }
      ]
    },
    "faq": {
      "overline": "FAQ",
      "title": "Preguntas comunes",
      "items": [
        {
          "question": "¿Esto sirve si apenas voy empezando?",
          "answer": "Sí. Una landing bien hecha ayuda a explicar tu oferta y dar confianza aunque todavía no tengas un sitio grande."
        },
        {
          "question": "¿Puedo agregar más secciones después?",
          "answer": "Sí. La idea es empezar enfocado y crecer sin tirar lo anterior."
        },
        {
          "question": "¿Incluye dominio y hosting?",
          "answer": "Te puedo orientar con dominio, hosting y despliegue. Se define según el caso para no venderte algo que no necesitas."
        },
        {
          "question": "¿Puede conectarse a WhatsApp o formulario?",
          "answer": "Sí. Podemos llevar el CTA a WhatsApp, formulario, correo o una integración más avanzada."
        }
      ]
    },
    "cta": {
      "title": "¿Quieres una landing que sí parezca de tu negocio?",
      "description": "Cuéntame qué vendes y te propongo una ruta simple para arrancar sin inflar el proyecto.",
      "button": "Quiero una idea para mi negocio"
    }
  }
}
